<script setup lang="ts">
  import { useClipboard } from '@vueuse/core';
  import { watch } from 'vue';

  import { toast } from '@ui/components/sonner';

  interface Props {
    allowCopy?: boolean;
    label?: string;
    value?: string;
  }

  const props = defineProps<Props>();

  const { copied, copy } = useClipboard({ source: props.value });

  watch(copied, () => {
    if (copied.value) {
      toast.info('Copied to clipboard');
    }
  });
</script>

<template>
  <div
    class="group flex flex-row cursor-pointer bg-background rounded p-0.5 h-8 gap-1 items-center font-medium"
    @click="allowCopy && copy()"
  >
    <div v-if="label" class="p-2 [&>span]:group-hover:opacity-70">
      <span> {{ label }} </span>
    </div>

    <div
      class="rounded h-full bg-accent text-primary px-2 items-center align-center flex flex-row justify-center *:group-hover:opacity-70"
    >
      <slot>
        <span> {{ value }} </span>
      </slot>
    </div>
  </div>
</template>

<style scoped></style>
